import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { pushNotification } from "utils/notifications";
import { useForm } from "react-hook-form";
import ReactDropdown from "react-dropdown";
import TraGopApi from "service/traGopApi";
import { ReactToPrint, useReactToPrint } from "react-to-print";
import { formatNumber } from "utils/currencyFormat";

class ComponentToPrint extends React.Component {
  render() {
    return (
      <div className="col-sm-12" style={{ width: "100%", color: "#000000" }}>
        <div
          style={{ padding: "15px" }}
          dangerouslySetInnerHTML={{ __html: this.props.data }}
        ></div>
      </div>
    );
  }
}
export const ModalInDanhSachDongLai = (props) => {
  const componentRef = useRef();
  const listMauIn = {
    titleMauIn: [
      {
        value: "1",
        label: "Form đóng lãi",
      },
      {
        value: "0",
        label: "Tắt lãi/gốc",
      },
    ],
  };

  const init = {
    chovayId: props.data.ChoVayId,
    isHienLaiGoc: 1,
  };
  const [dataIn, setDataIn] = useState(init);
  const [dataContent, setDataContent] = useState("");
  const [loadingData, setLoadingData] = useState(false);

  const updateDropdown = (field) => (e) => {
    setLoadingData(true);
    const obj = { ...dataIn };
    obj.isHienLaiGoc = e.target.value;
    setDataIn(obj);
    TraGopApi.inDanhSachDongLai(props.data.ChoVayId, e.target.value).then(
      (response) => {
        if (response.status === 200) {
          setLoadingData(false);
          setDataContent(response.data);
        } else {
          setLoadingData(false);
        }
      }
    );
  };

  useEffect(() => {
    setLoadingData(true);
    TraGopApi.inDanhSachDongLai(props.data.ChoVayId, dataIn.isHienLaiGoc).then(
      (response) => {
        if (response.status === 200) {
          setLoadingData(false);
          setDataContent(response.data);
        } else {
          setLoadingData(false);
        }
        console.log(response, "aaaaaaaaaaainDongLai");
      }
    );
  }, []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-printer"></i>
          </span>
          In phiếu
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="color-print formLoading">
        <div
          className={
            "loader loader-default " + (loadingData ? "is-active" : "")
          }
        ></div>
        {/* <div ref={(el) => (this.componentRef = el)}>
          <div
            style={{ width: "100%", color: "#000000", padding: "10px" }}
            dangerouslySetInnerHTML={{ __html: dataIn }}
          ></div>
        </div> */}
        <ComponentToPrint data={dataContent} ref={componentRef} />
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size modal-footer">
        {/* {ListCombo[Type] && (
            <div class="col-sm-3">
              <ReactDropdown
                onChange={this.onChangeMauIn()}
                options={ListCombo[Type]}
                controlClassName="form-control input-sm ml-1 pad-col"
                value={tenMauIn}
              />
            </div>
          )} */}
        <div class="col-sm-3">
          {/* <ReactDropdown
            onChange={updateDropdown("isHienLaiGoc")}
            options={listMauIn.listMauIn}
            controlClassName="form-control input-sm ml-1 pad-col"
            value={dataIn.isHienLaiGoc}
          /> */}
          <select
            name="nhanvien"
            className="selectBox form-control input-sm"
            value={dataIn.isHienLaiGoc}
            onChange={updateDropdown("isHienLaiGoc")}
          >
            <option value="1">Form đóng lãi</option>
            <option value="0">Tắt lãi/gốc</option>
          </select>
        </div>
        {/* <ReactToPrint
          trigger={() => {
            return (
              <a class="btn btn-new-main btn-checknew" href={() => false}>
                <span class="btn-icon-left">
                  <i class="mdi mdi-printer"></i>
                </span>{" "}
                In phiếu
              </a>
            );
          }}
          content={() => this.componentRef}
          copyStyles={false}
        /> */}
        <a
          class="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={handlePrint}
        >
          <span class="btn-icon-left">
            <i class="mdi mdi-printer"></i>
          </span>{" "}
          In phiếu
        </a>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
